import { createUseStyles } from 'react-jss'

export const style = {
  nodeRect: {
    cursor: 'pointer'
  },
  nodeHighlight: {
    stroke: 'black',
    strokeWidth: 2
  },
  disabled: {
    opacity: '0.5',
    pointerEvents: 'none'
  }
}

export const useStyles = createUseStyles(style)
